import { useParams, Link } from 'react-router-dom';
import { companies } from '../../mocks/companies';
import TikTokEmbed from '../../components/feature/TikTokEmbed';

export default function CompanyPage() {
  const { id } = useParams();
  const company = companies.find(c => c.id === Number(id));

  if (!company) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500">企業が見つかりませんでした</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between" style={{ height: '100px' }}>
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/bf28291cc5d7f0a9c8281f40e0310854/bac760dd5111dec7a1acf46dcaf57f3b.jpeg"
              alt="縦長ジョブ"
              className="h-16 w-auto"
            />
          </Link>
          <Link
            to="/"
            className="text-sm text-gray-600 hover:text-black cursor-pointer flex items-center gap-1"
          >
            <i className="ri-arrow-left-line"></i>
            戻る
          </Link>
        </div>
      </header>

      {/* Company Booth */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        {/* Video Section */}
        <div className="mb-8">
          <div className="max-w-md mx-auto">
            <TikTokEmbed videoId={company.tiktokVideoId} />
          </div>
          <p className="text-center text-xs text-gray-400 mt-3">
            ※ 動画が表示されない場合は、TikTokアプリまたはブラウザで直接ご覧ください
          </p>
          <div className="text-center mt-2">
            <a
              href={`https://www.tiktok.com/@user/video/${company.tiktokVideoId}`}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-black cursor-pointer transition-colors"
            >
              <i className="ri-external-link-line"></i>
              TikTokで見る
            </a>
          </div>
        </div>

        {/* Company Info */}
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold mb-4">{company.name}</h1>
          <div className="flex flex-wrap justify-center gap-2 mb-6">
            {company.tags.map((tag, idx) => (
              <span
                key={idx}
                className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-full text-sm"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        {/* Editor's Note */}
        <div className="bg-gray-50 rounded-2xl p-6 mb-12">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-black text-white rounded-full flex-shrink-0">
              <i className="ri-quill-pen-line text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold mb-2">編集部メモ</h3>
              <p className="text-gray-700 leading-relaxed">{company.description}</p>
            </div>
          </div>
        </div>

        {/* Live Schedule */}
        <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-8 mb-12">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
            <h2 className="text-2xl font-bold">説明会スケジュール</h2>
          </div>
          <div className="space-y-4">
            {company.upcomingSessions.map((session, idx) => (
              <div
                key={idx}
                className="bg-white rounded-xl p-5 flex items-center justify-between"
              >
                <div>
                  <p className="font-bold text-lg mb-1">{session.date}</p>
                  <p className="text-gray-600">{session.time}</p>
                  <p className="text-sm text-gray-500 mt-1">{session.platform}</p>
                </div>
                <button className="px-6 py-3 bg-black text-white rounded-full font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer">
                  視聴する
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-gray-600 mb-4">気になったら、まずは説明会を見てみよう</p>
          <Link
            to="/sessions"
            className="inline-block px-8 py-4 bg-black text-white rounded-full font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            他の説明会も見る
          </Link>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-12 px-4 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <img
                src="https://static.readdy.ai/image/bf28291cc5d7f0a9c8281f40e0310854/bac760dd5111dec7a1acf46dcaf57f3b.jpeg"
                alt="縦長ジョブ"
                className="h-48 w-auto mb-4"
              />
              <p className="text-sm text-gray-400">
                縦動画で見つける、新しい仕事との出会い
              </p>
            </div>
            <div>
              <h4 className="font-bold mb-4">サイトマップ</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>
                  <Link to="/" className="hover:text-white cursor-pointer">
                    ホーム
                  </Link>
                </li>
                <li>
                  <Link to="/sessions" className="hover:text-white cursor-pointer">
                    説明会一覧
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="hover:text-white cursor-pointer">
                    利用規約
                  </Link>
                </li>
                <li>
                  <Link to="/privacy" className="hover:text-white cursor-pointer">
                    プライバシーポリシー
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-4">対象業界</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>飲食</li>
                <li>小売</li>
                <li>物流</li>
                <li>製造</li>
              </ul>
            </div>
          </div>
          <div className="pt-8 border-t border-gray-800 text-center text-sm text-gray-400">
            <p>
              © 2025 縦長ジョブ. All rights reserved. |{' '}
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white cursor-pointer"
              >
                Powered by Readdy
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
